// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3877":"fe336940f98fdfab","4213":"e09d907904604b2f","6676":"72b5415ebc1bbdb0","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};